// Single source of truth for the "X of Y voted" tally. Guests are real voters
// (counted in the numerator); the denominator grows by the number of guests who
// voted so the count is guest-inclusive AND never shows X>Y.
//
// Counter fields (denormalized onto scheduler + basicPoll docs by the
// functions triggers):
//   totalSubmittedVoteCount  — guest-INCLUSIVE total submitted (alias: submittedVoteCount)
//   participantSubmittedVoteCount — participant-only submitted (excludes guests)
//   totalParticipantCount    — eligible participants (no guests)
//   votesAllSubmitted        — all participants voted
//
// Mirror: functions/src/utils/vote-tally.js (keep behavior identical; guarded by
// the parity test).

function num(value) {
  return Number.isFinite(value) ? value : 0;
}

export function getVoteTally(counters = {}) {
  const totalVoted = num(counters.totalSubmittedVoteCount ?? counters.submittedVoteCount);
  // Fallback: when the participant-only split is unknown, treat all votes as
  // participant votes (no guest split known) → guestVoted resolves to 0 below
  // and the denominator stays participant-only, preserving legacy behavior.
  const participantVoted = Number.isFinite(counters.participantSubmittedVoteCount)
    ? counters.participantSubmittedVoteCount
    : totalVoted;
  const guestVoted = Math.max(0, totalVoted - participantVoted);
  const participantTotal = num(counters.totalParticipantCount);
  const pendingCount = Math.max(0, participantTotal - participantVoted); // participant-based
  const displayTotal = participantTotal + guestVoted; // guest-aware denominator → X ≤ Y
  return {
    totalVoted,
    participantVoted,
    guestVoted,
    participantTotal,
    pendingCount,
    displayTotal,
    hasGuests: guestVoted > 0,
    allVoted:
      counters.votesAllSubmitted === true ||
      (participantTotal > 0 && pendingCount === 0),
  };
}
